import { forwardRef } from 'react';
import { InputProps } from '../../../../types/Form';
import { getAcceptedFileTypes } from '../../../../utils';
import InputError from '../Error';
import styles from './FileInput.module.css';

const FileInput = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      label,
      id,
      error,
      customClassName,
      name,
      value,
      accept = getAcceptedFileTypes(),
      ...rest
    },
    ref
  ) => (
    <div className={`${customClassName}`}>
      <label
        className={`leading-7 block text-sm font-medium text-neutralColor-medium`}
        htmlFor={id || name}
      >
        {label}
      </label>
      <div className='flex w-full'>
        <label htmlFor={id || name} className='flex-1 w-2/3'>
          <span
            className={`${
              error ? styles['form-input-error'] : styles['form-input-normal']
            }`}
          >
            <span className='py-2 px-3 truncate'>{value}</span>
          </span>
        </label>
        <div className={styles['upload-button']}>
          <span>Choose File</span>
          <input
            className={`absolute opacity-0 cursor-pointer`}
            id={id || name}
            ref={ref}
            name={name}
            accept={accept}
            autoComplete={id || name}
            {...rest}
          />
        </div>
      </div>
      {error && <InputError>{error}</InputError>}
    </div>
  )
);

export default FileInput;
